import React, { useState, useEffect } from "react";
import { UCWords } from "../../utils/helpers";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { LOAD_AREAS_LIST } from "../../utils/apiPath";
import { agent } from "../../utils/agent";
import { Tooltip } from "@mui/material";
import config from "../../config";
import { imgPath } from "../../utils/imagePath";
import queryString from "query-string";

const Filter = () => {

  const [searchDomain, setSearchDomain] = useState("");
  const [mentalHealth, setMentalHealth] = useState("");
  const [certifiedCoach, setCertifiedCoach] = useState("");
  const [areas, setAreas] = useState([]);

  const getAreasData = (page = 1) => {
    agent
      .get(LOAD_AREAS_LIST, {})
      .then((res) => {
        setAreas(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const location = useLocation();

  useEffect(() => {
    getAreasData();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    if (params.get("domains")) {
      const keyword = queryStringParsed["domains"];
      setSearchDomain(keyword);
    }
    if (params.get("mf_mental_health")) {
      const mf_mental_health = queryStringParsed["mf_mental_health"];
      setMentalHealth(mf_mental_health);
    }
    if (params.get("mf_certified_coach")) {
      const mf_certified_coach = queryStringParsed["mf_certified_coach"];
      setCertifiedCoach(mf_certified_coach);
    }
  }, [location]);

  const history = useNavigate();

  const resetPage = () => {
    history(location?.pathname, { replace: true });
  };

  const [selectedDomain, setSelectedDomain] = useState([]);

  const setSelectedDomainArray = (e) => {
    const val = e.target.value;
    let cloneSelected = [...selectedDomain];
    if (selectedDomain.includes((item) => item === val)) {
      cloneSelected = selectedDomain.filter((item) => item !== val);
    } else {
      cloneSelected.push(val);
    }
    setSelectedDomain(cloneSelected);
    // Set parameter for searching data
    const params = new URLSearchParams(location.search);
    params.set("domains", cloneSelected);
    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history({
      pathname: location?.pathname,
      search: "?" + params,
    });
  };

  const setSelectedHealth = (e, type) => {
    const val = e.target.checked;
    const params = new URLSearchParams(location.search);
    if (type == "mf_mental_health") {
      if (val) {
        params.set("mf_mental_health", 1);
        setMentalHealth(1);
      } else {
        params.set("mf_mental_health", "");
        setMentalHealth("");
      }
    }
    if (type == "mf_certified_coach") {
      if (val) {
        params.set("mf_certified_coach", 1);
        setCertifiedCoach(1);
      } else {
        params.set("mf_certified_coach", "");
        setCertifiedCoach("");
      }
    }
    // Set parameter for searching data

    history({
      pathname: location?.pathname,
      search: "?" + params,
    });
  };

  return (

    <div className="sidebar">
      <div className="sidebar_heading seprator">
        <h3 className="d-flex align-items-center">
          Filters
          <Link to="" onClick={resetPage} className="link ms-auto">
            {"Reset Filters"}
          </Link>
        </h3>
      </div>
      <div className="sidebar_toggle">
        <div className="seprator">
          <h6>Select Domain</h6>
          <ul>
            {/* {areas && */}
            {areas.map((item) => (
              <li key={item.id}>
                <span className="custom_check">
                  {UCWords(item.name)} &nbsp;{" "}
                  <input
                    value={item.id}
                    type="checkbox"
                    onClick={(e) => setSelectedDomainArray(e)}
                    defaultChecked={searchDomain.includes(item.id.toString())}
                  />
                  <span className="check_indicator">&nbsp;</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="seprator health_check">
          <ul>
            <li>
              <span className="custom_check">
                &nbsp;{" "}
                <input
                  value={mentalHealth}
                  type="checkbox"
                  onClick={(e) => setSelectedHealth(e, "mf_mental_health")}
                  defaultChecked={mentalHealth}
                ></input>
                <span className="check_indicator">&nbsp;</span>
              </span>
              <Tooltip
                size="4xl"
                title={<h5>{config?.mf_mental_health}</h5>}
                describeChild
                arrow
              >
                <img alt="" src={imgPath + "usermind.svg"} />
              </Tooltip>{" "}
            </li>
            <li>
              <span className="custom_check">
                &nbsp;{" "}
                <input
                  type="checkbox"
                  value={certifiedCoach}
                  onClick={(e) => setSelectedHealth(e, "mf_certified_coach")}
                  defaultChecked={certifiedCoach}
                ></input>
                <span className="check_indicator">&nbsp;</span>
              </span>
              <Tooltip
                size="4xl"
                title={<h5>{config?.mf_certified_coach}</h5>}
                describeChild
                arrow
              >
                <img alt="" src={imgPath + "useraward.svg"} />
              </Tooltip>{" "}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Filter;
